import React from "react";
import Item from "./Item";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    height: "inherit"
  },
  centerCol: {
    flex: 1,
    overflowY: "scroll"
  }
}));


const ListItems = ({ items }: any) => {
  const classes = useStyles();

  return (
    <div>
      <div style={{ alignContent: "center" }}>
        <h1 className="result-research">Resultat de la recherche</h1>
      </div>
      {(!items || items.length === 0) && 
      <div style={{textAlign: 'center'}}>
        <p>Pas d'article pour ce jour ou ils sont déjà tous séléctionnés</p>
      </div>
      }
      <div className={classes.container}>
        <div className={classes.centerCol}>
          {items.map((item: any, index: any) => (
            <Item key={index} item={item}></Item>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListItems;
